// @flow

import type Neighborhood from 'models/Neighborhood';
import type NeighborhoodZip from 'models/NeighborhoodZip';

export const GET_NEAREST_NEIGHBORHOODS: 'get/nearest_neighborhoods' = 'get/nearest_neighborhoods';
export const NEIGHBORHOODS_BY_ZIP: 'get/neighborhoods_by_zip' = 'get/neighborhoods_by_zip';
export type Action =
  | {
    type:typeof GET_NEAREST_NEIGHBORHOODS,
    neighborhoods: Array<Neighborhood>,
  }
  | {
    type: typeof NEIGHBORHOODS_BY_ZIP,
    neighborhoods: Array<NeighborhoodZip>,
    index: number | string
  }
  ;
